import React from "react";
import createReactClass from "create-react-class";
import * as UrlHelpers from "../../libs/UrlHelpers";

const DetailPageClose = createReactClass({
  render: function () {
    return (
      <div className="detail-page__close-btn" onClick={UrlHelpers.navigateBackOrToResult}>
        <span className="ficon ficon__close-thin detail-page__close-icon" />
      </div>
    );
  },
});

export default DetailPageClose;
